import { AiFillCheckCircle } from "react-icons/ai";
import CloseDetailPage from "../CloseComponent/CloseDetailPage";
import DetailWrapper from "../detailWrapper";
import { useTranslation } from "react-i18next";
import { Button } from "semantic-ui-react";
import { useNavigate } from "react-router";
import { RiCustomerService2Fill } from "react-icons/ri";
import { GoAlertFill } from "react-icons/go";
import { useMemo } from "react";
import QRCode from "qrcode.react";
import InputCopy from "../CopyComponent/InputCopy";

const ResultPage = ({
  pageTitle,
  pageType = "success",
  resultText,
  resultContent,
  buttonProps,
  children,
  CONTENT,
} = {}) => {
  const { content, path, onClick } = buttonProps;

  const navigate = useNavigate();
  const style = useMemo(() => {
    switch (pageType) {
      case "success":
        return {
          circleStyle: "bg-green-500",
          iconStyle: "text-green-500 text-5xl",
        };
      case "service":
        return {
          circleStyle: "bg-yellow-500",
          iconStyle: "text-yellow-500 text-5xl",
        };
      case "warning":
        return {
          circleStyle: "bg-yellow-500",
          iconStyle: "text-yellow-500 text-5xl",
        };
      default:
        return {
          circleStyle: "bg-green-500",
          iconStyle: "text-green-500 text-5xl",
        };
    }
  }, [pageType]);

  const { circleStyle = "", iconStyle = "" } = style;

  return (
    <DetailWrapper
      closeAnimate
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1] bg-gradient-to-br`}
    >
      <CloseDetailPage title={pageTitle} />
      {children}
      <article className="flex flex-col gap-[15px] p-[15px] text-transaction-text font-medium pt-[50px]">
        <div className="flex items-center justify-center relative mb-[40px]">
          <div
            className={`absolute absolute-center w-[100px] h-[100px] ${circleStyle} opacity-[0.15] rounded-full`}
          ></div>
          {pageType === "success" ? (
            <AiFillCheckCircle className={iconStyle} />
          ) : pageType === "service" ? (
            <RiCustomerService2Fill className={iconStyle} />
          ) : pageType === "warning" ? (
            <GoAlertFill className={iconStyle} />
          ) : null}
        </div>
        <div className="flex items-center justify-center">
          <span className="text-2xl text-transaction-text dark:text-base-light-white text-2xl">
            {resultText}!!
          </span>
        </div>
        <div className="flex items-center justify-center text-light-gray">
          <span>{resultContent}</span>
        </div>
        {CONTENT}
        <Button
          type="button"
          onClick={() => {
            localStorage.clear();
            navigate(path);
            if (onClick) {
              onClick();
            }
          }}
          content={content}
          size="xl"
          className="!bg-main-color !text-white !w-full !py-[17px] !mt-[20px]"
        />
      </article>
    </DetailWrapper>
  );
};

export default ResultPage;
